module.exports = __webpack_public_path__ + "media/leaderboard/assets/proxima-nova-alt-bold-da0d3d7c61c9e115d42fa58b5ae26250.otf";